import { useFieldArray } from 'react-hook-form';

import { Button, IconButton, InputPhoneController } from '../../Shared';

export const PhoneNumbersField = ({ control, trigger, errors }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'phoneNumbers',
  });

  const appendField = async () => {
    append({ value: '', isBestPhoneNumber: 0 });
    await trigger('phoneNumbers');
  };

  const removeField = (isBestPhoneNumber, idx) => {
    if (isBestPhoneNumber) return;
    remove(idx);
  };

  const isAddPhoneNumberButtonDisabled = Array.isArray(errors?.phoneNumbers);

  return (
    <div className="flex flex-col gap-1">
      <label className="font-medium text-[16px]/[24px] text-base-800">
        Phone Number
      </label>
      <div className="flex flex-col gap-3">
        {fields.map(({ id, isBestPhoneNumber }, idx) => {
          const isFieldDisabled = Boolean(isBestPhoneNumber);

          return (
            <div key={id} className="flex items-center gap-2">
              <div className="flex-1">
                <InputPhoneController
                  control={control}
                  name={`phoneNumbers.${idx}.value`}
                  readOnly={isFieldDisabled}
                />
              </div>
              <div className="text-brand-500">
                <IconButton
                  buttonProps={{
                    onClick: () => {
                      removeField(isBestPhoneNumber, idx);
                    },
                    className: 'w-12 h-12',
                    disabled: isFieldDisabled,
                  }}
                  iconProps={{
                    name: isFieldDisabled ? 'remove-disabled' : 'remove',
                    alt: 'remove',
                    className: 'h-5',
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div>
        <Button
          title="+ Add Phone Number"
          variant="text"
          onClick={appendField}
          disabled={isAddPhoneNumberButtonDisabled}
          className="text-brand-500"
        />
      </div>
    </div>
  );
};
